import React, { useEffect, useState } from "react";
import { DatePicker, Row, Col, } from "antd";

import "./Report.css";
import "../../Components/Commons/Commons.css";

import SidebarMenu from "../../Components/Sidebar/Sidebar";
import AntDTable from "../../Components/AntDTable/AntDTable";
import BtnExcel from "../../Components/Commons/Buttons/BtnExcel";
import BtnDownloadTable from "../../Components/Commons/Buttons/BtnDownloadTable";
import LabelHeader from "../../Components/Commons/LabelHeader";

import { useParams } from "react-router-dom";
import { getSingleCensusOfDisease } from "../../Components/Helpers/API/ReportsApi/ReportsApi";
import { getTodayDateISO, formatDateWithTime } from "../../Helpers/Utils/Common";
import dayjs from "dayjs";
import { capitalizeFirstLetter } from "../../Components/Helpers/Utilities/Common";

const { RangePicker } = DatePicker;

function ViewCensusOfDiseases() {
  const { diagnosis } = useParams();
  const decodedDiagnosis = decodeURIComponent(diagnosis);
  const [showLoader, setShowLoader] = useState(false);
  const [data, setData] = useState([]);
  const [excelData, setExcelData] = useState([]);
  const xlsxHeaders = ["Name", "Age", "Sex", "Contact No."];
  const [filterConfig, setFilterConfig] = useState({
    date_from: "",
    date_to: "",
  })

  //Handler function for date range picker filter
  function handleDateFilterChange(dates){
    var [dateFrom, dateTo] = dates || [];
    setFilterConfig((prev) => ({
      ...prev,
      date_from: dateFrom ? dateFrom.format("YYYY-MM-DD") : "",
      date_to: dateTo ? dateTo.format("YYYY-MM-DD") : "",
    }));
  }

  // Function get for single census of disease API
  async function fetchSingleCensusOfDisease() {
    setShowLoader(true);
    const res = await getSingleCensusOfDisease({ 
        diagnosis: decodedDiagnosis,
        date_from: filterConfig.date_from,
        date_to: filterConfig.date_to, 
      });

    if (res.data) {
      // var _parsed = res.data.data.map((patient) => {
      //   delete patient.diagnosis;
      //   return patient;
      // });
      var _parsed = res.data.data.map((patient) => ({
        ...patient,
        formatted_sex: capitalizeFirstLetter(patient.patient_sex),
      }));
      setData(_parsed);
      var _parsedExcel = res.data.data.map((log) => {
        return {        
          formatted_patient_name: log.formatted_patient_name,
          patient_age: log.patient_age,
          patient_sex: capitalizeFirstLetter(log.patient_sex),
          patient_phone_no: log.patient_phone_no,
        };
      });
      setExcelData(_parsedExcel);
    } else if (res.error) {
      setData([]);
    }
    setShowLoader(false);
  }

  useEffect(() => {
    fetchSingleCensusOfDisease();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterConfig]);

  return (
    <div className="App">
      <SidebarMenu active={"Reports"} active_sub={"Census of Diseases"} />
      <div className="col p-5 pt-4 manager-container">
        <div className="row pt-3">
          <div className="col font-big title-2 all-patient">
            <LabelHeader text={`Census of Diseases: ${decodedDiagnosis}`} />
          </div>
          <div className="col-2 patient-manager">
            <BtnDownloadTable
                label={"Download PDF"}
                size={"sm"}
                data={{
                  body: data,
                  columns: [
                    { header: "NAME", dataKey: "formatted_patient_name" },
                    { header: "AGE", dataKey: "patient_age" },
                    { header: "SEX", dataKey: "formatted_sex" },
                    { header: "CONTACT NO.", dataKey: "patient_phone_no" },
                  ],
                }}
                fileName={`${getTodayDateISO()}__Census_of_${decodedDiagnosis}.pdf`}
                pdfHeader={{
                  title: `Census of Disease`,
                  content: `This Census of Disease is generated on ${formatDateWithTime(
                    new Date()
                  )}.`,
                }}
              />
          </div>
          <div className="col-2 patient-manager">
            <BtnExcel
              label={"Download Excel"}
              size={"sm"}
              excelData={excelData}
              xlsxHeaders={xlsxHeaders}
              fileName={`${getTodayDateISO()}__Census_of_${decodedDiagnosis}.xlsx`}
            />
          </div>
        </div>
        <Row>
          <Col>
            <div className="row justify-content-start">
              <div className=" pl-0 mb-3">
              <RangePicker
                placeholder={["Start Date", "End Date"]}
                className="w-full m-2"
                format="YYYY-MM-DD" 
                value={[
                  filterConfig.date_from ? dayjs(filterConfig.date_from) : null,
                  filterConfig.date_to ? dayjs(filterConfig.date_to) : null,
                ]}
                onChange={(dates) => {
                  handleDateFilterChange(dates)
                }}
                showTime={false}
                allowClear={true}
              />
              </div>
            </div>
          </Col>
        </Row>
        <div className="row justify-content-center">
          <div className="col-sm-12" id="antd-table-container">
            <AntDTable
              tableHeaders={["Name", "Age", "Sex", "Contact No."]}
              headerSelector={[
                "formatted_patient_name",
                "patient_age",
                "formatted_sex",
                "patient_phone_no",
              ]}
              tableData={data}
              loading={showLoader}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewCensusOfDiseases;
